import React from "react";

/**
 * CosmosBackdrop — fixed, full-viewport galactic backdrop.
 * Sparse, static starfield + faint nebula band. Stars are deterministic
 * (seeded RNG) so they don't reshuffle on every render.
 *
 * Mount ONCE near the root (App.jsx). Sits at z-index 0; all app chrome
 * should sit at z-index >= 1.
 */
export default function CosmosBackdrop() {
  const stars = React.useMemo(() => {
    const rng = (seed) => {
      const x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    };
    return Array.from({ length: 280 }, (_, i) => {
      const sizeRoll = rng(i * 4.7);
      let size, opacity, glow;
      if (sizeRoll > 0.97) {
        size = 2.4 + rng(i * 9.1) * 1.2;
        opacity = 0.85 + rng(i * 11.3) * 0.15;
        glow = true;
      } else if (sizeRoll > 0.78) {
        size = 1.4 + rng(i * 6.3) * 0.8;
        opacity = 0.5 + rng(i * 3.7) * 0.35;
        glow = false;
      } else {
        size = 0.7 + rng(i * 8.9) * 0.6;
        opacity = 0.25 + rng(i * 5.1) * 0.4;
        glow = false;
      }
      const color = rng(i * 17.7) > 0.88 ? "rgba(140, 235, 195, 1)" : "#EFEAD8";
      return {
        top: rng(i * 7.3) * 100,
        left: rng(i * 13.1) * 100,
        size, opacity, glow, color,
      };
    });
  }, []);

  return (
    <div
      aria-hidden="true"
      style={{ position: "fixed", inset: 0, pointerEvents: "none", zIndex: 0, overflow: "hidden" }}
    >
      {stars.map((s, i) => (
        <span
          key={i}
          className={s.glow ? "mb-star-bright" : undefined}
          style={{
            position: "absolute",
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            backgroundColor: s.color,
            color: s.color,
            borderRadius: "50%",
            opacity: s.opacity,
          }}
        />
      ))}
    </div>
  );
}
